import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';

export const BrandFilterWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => (props.$disabled ? colors.lightGray7 : 'transparent')};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
`;

export const tagStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    minHeight: '25px',
    height: '25px',
    borderColor: state.menuIsOpen ? colors.blue1 : colors.lightGray21,
    backgroundColor: colors.white,
    '&:hover': {
      backgroundColor: colors.white,
      borderColor: state.menuIsOpen ? colors.blue1 : colors.lightGray21,
    },
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: '0px 2px',
    gap: '4px',
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: colors.blue13,
    borderRadius: '4px',
    border: 'none',
    margin: '0',
    marginLeft: '0',
    marginTop: '0',
    minWidth: 'unset',
    height: '20px',
    padding: '0 4px',
    display: 'flex',
    alignItems: 'center',
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: colors.black4,
    fontSize: '11px',
    fontWeight: '400',
    padding: '0',
    paddingLeft: '0',
    lineHeight: '20px',
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: colors.inputGrey,
    cursor: 'pointer',
    paddingLeft: '4px',
    paddingRight: '0',
    '&:hover': {
      backgroundColor: 'transparent',
      color: colors.black4,
    },
  }),
  clearIndicator: () => ({
    display: 'none',
  }),
};
